import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';
import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';
import Payment, { ShopProduct } from '../../../interfaces/Payment';

@Component({
  template: require('./upgrade-course.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
})
export class Upgradecourse extends vue {
  course = '';
  paymentsProvider = IocContainer.get<Payment>(SERVICES.PAYMENT);
  availableCourses: ShopProduct[] = [];
  loadError = '';

  async mounted() {
    try {
      const products = await this.paymentsProvider.getProducts();
      this.availableCourses = products.filter(p => p.type === 'upgrade');
    } catch (e) {
      this.loadError = (e && e.response && e.response.data && e.response.data.message) || 'Unable to load upgrade options.';
    }
  }

  // Preloader
  get loading() {
    return this.$store.state.loadingUser;
  }  
  get courseId() {
    return this.$store.state.course_id;
  }

  setDays(e) {
    this.course = e.target.options[e.target.options.selectedIndex].getAttribute('data-key');
  }

  openCheckout() {
    if (!this.course) {
      return;
    }
    this.$router.push({ name: 'checkout', params: { product: 'upgrade', selectedCourse: this.course } });
  }
}
